import { timeInterval as r } from "./interval.js";
import { durationMinute as n, durationSecond as i } from "./duration.js";
const o = r((e) => {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * i);
}, (e, t) => {
  e.setTime(+e + t * n);
}, (e, t) => (t - e) / n, (e) => e.getMinutes());
o.range;
const s = r((e) => {
  e.setUTCSeconds(0, 0);
}, (e, t) => {
  e.setTime(+e + t * n);
}, (e, t) => (t - e) / n, (e) => e.getUTCMinutes());
s.range;
export {
  o as timeMinute,
  s as utcMinute
};
